import React, { useState } from "react";
import { TextField, Select, MenuItem, Typography, Box, FormControl, InputLabel, OutlinedInput } from "@mui/material";

// import flagFR from "../../../../assets/images"

import FlagFR from "../../../assets/images/flags/4x3/fr.svg";
import FlagDE from "../../../assets/images/flags/4x3/de.svg";
import FlagES from "../../../assets/images/flags/4x3/es.svg";
import FlagRU from "../../../assets/images/flags/4x3/ru.svg";
import FlagET from "../../../assets/images/flags/4x3/ee.svg";
import FlagHU from "../../../assets/images/flags/4x3/hu.svg";
import FlagPL from "../../../assets/images/flags/4x3/pl.svg";
import FlagEU from "../../../assets/images/flags/4x3/us.svg";
import FlagEB from "../../../assets/images/flags/4x3/gb.svg";
import FlagEL from "../../../assets/images/flags/4x3/gr.svg";
import FlagFI from "../../../assets/images/flags/4x3/fi.svg";
import FlagJA from "../../../assets/images/flags/4x3/jp.svg";
import FlagIT from "../../../assets/images/flags/4x3/it.svg";
import FlagLT from "../../../assets/images/flags/4x3/lt.svg";
import FlagNL from "../../../assets/images/flags/4x3/nl.svg";
import FlagZH from "../../../assets/images/flags/4x3/cn.svg";
import FlagSV from "../../../assets/images/flags/4x3/se.svg";
import FlagPP from "../../../assets/images/flags/4x3/pt.svg";
import FlagPB from "../../../assets/images/flags/4x3/br.svg";
import FlagBG from "../../../assets/images/flags/4x3/bg.svg";
import FlagCS from "../../../assets/images/flags/4x3/cz.svg";
import FlagDA from "../../../assets/images/flags/4x3/dk.svg";
import FlagLV from "../../../assets/images/flags/4x3/lv.svg";
import FlagSL from "../../../assets/images/flags/4x3/si.svg";
import FlagSK from "../../../assets/images/flags/4x3/sk.svg";
import FlagRO from "../../../assets/images/flags/4x3/ro.svg";
import FlagID from "../../../assets/images/flags/4x3/id.svg";
import FlagKR from "../../../assets/images/flags/4x3/kr.svg";
import FlagNO from "../../../assets/images/flags/4x3/no.svg";
import FlagTR from "../../../assets/images/flags/4x3/tr.svg";
import FlagUA from "../../../assets/images/flags/4x3/ua.svg";
import { useTranslation } from "react-i18next";
const TelephoneInput = (props) => {
  const { t } = useTranslation();

  const countries = [
    {
      text: t("Deutschland"),
      value: "DE",
      icon: FlagDE,
      telephonePrefix: "+49",
    },
    {
      text: t("Bulgarien"),
      value: "BG",
      icon: FlagBG,
      telephonePrefix: "+359",
    },
    {
      text: t("Tschechien"),
      value: "CS",
      icon: FlagCS,
      telephonePrefix: "+420",
    },
    {
      text: t("Dänemark"),
      value: "DA",
      icon: FlagDA,
      telephonePrefix: "+45",
    },
    {
      text: t("Griechenland"),
      value: "EL",
      icon: FlagEL,
      telephonePrefix: "+30",
    },
    {
      text: t("Englisch (Britisch)"),
      value: "EB",
      icon: FlagEB,
      telephonePrefix: "+44",
    },
    {
      text: t("Englisch (Amerikanisch)"),
      value: "EU",
      icon: FlagEU,
      telephonePrefix: "+1",
    },
    {
      text: t("Spanien"),
      value: "ES",
      icon: FlagES,
      telephonePrefix: "+34",
    },
    {
      text: t("Estland"),
      value: "ET",
      icon: FlagET,
      telephonePrefix: "+372",
    },
    {
      text: t("Finnland"),
      value: "FI",
      icon: FlagFI,
      telephonePrefix: "+358",
    },
    {
      text: t("Frankreich"),
      value: "FR",
      icon: FlagFR,
      telephonePrefix: "+33",
    },
    {
      text: t("Ungarn"),
      value: "HU",
      icon: FlagHU,
      telephonePrefix: "+36",
    },
    {
      text: t("Italien"),
      value: "IT",
      icon: FlagIT,
      telephonePrefix: "+39",
    },
    {
      text: t("Japan"),
      value: "JA",
      icon: FlagJA,
      telephonePrefix: "+81",
    },
    {
      text: t("Litauen"),
      value: "LT",
      icon: FlagLT,
      telephonePrefix: "+370",
    },
    {
      text: t("Lettland"),
      value: "LV",
      icon: FlagLV,
      telephonePrefix: "+371",
    },
    {
      text: t("Niederlande"),
      value: "NL",
      icon: FlagNL,
      telephonePrefix: "+31",
    },
    {
      text: t("Polen"),
      value: "PL",
      icon: FlagPL,
      telephonePrefix: "+48",
    },
    {
      text: t("Portugiesisch (alle portugiesischen Varietäten außer Brasilien)"),
      value: "PP",
      icon: FlagPP,
      telephonePrefix: "+351",
    },
    {
      text: t("Portugiesisch (Brasilien)"),
      value: "PB",
      icon: FlagPB,
      telephonePrefix: "+55",
    },
    {
      text: t("Rumänien"),
      value: "RO",
      icon: FlagRO,
      telephonePrefix: "+40",
    },
    {
      text: t("Russland"),
      value: "RU",
      icon: FlagRU,
      telephonePrefix: "+7",
    },
    {
      text: t("Slowakei"),
      value: "SK",
      icon: FlagSK,
      telephonePrefix: "+421",
    },
    {
      text: t("Slowenien"),
      value: "SL",
      icon: FlagSL,
      telephonePrefix: "+386",
    },
    {
      text: t("Schweden"),
      value: "SV",
      icon: FlagSV,
      telephonePrefix: "+46",
    },
    {
      text: t("China"),
      value: "ZH",
      icon: FlagZH,
      telephonePrefix: "+86",
    },
    {
      text: t("Indonesien"),
      value: "ID",
      icon: FlagID,
      telephonePrefix: "+62",
    },
    {
      text: t("Korea"),
      value: "KO",
      icon: FlagKR,
      telephonePrefix: "+82",
    },
    {
      text: t("Norwegen"),
      value: "NB",
      icon: FlagNO,
      telephonePrefix: "+47",
    },
    {
      text: t("Türkei"),
      value: "TR",
      icon: FlagTR,
      telephonePrefix: "+90",
    },
    {
      text: t("Ukraine"),
      value: "UK",
      icon: FlagUA,
      telephonePrefix: "+380",
    },
  ];
  const { value, onChange, label } = props;
  const [country, setCountry] = useState(countries[0]);
  // const [value, setValue] = useState("");
  const handleCountryChange = (event) => {
    setCountry(countries.find((e) => e.telephonePrefix === event.target.value));
    onChange(event.target.value);
  };

  const [previousValue, setPreviousValue] = useState("");

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    const cleanedValue = newValue.replace(/\D/g, "");
    const prefixLength = country.telephonePrefix.replace(/\D/g, "").length;
    const isRemovingNumber = cleanedValue.length < previousValue.replace(/\D/g, "").length || newValue.length < value.length;

    if (newValue.length < prefixLength + 1 && isRemovingNumber) {
      return;
    }
    if (newValue.length < prefixLength + 1) {
      const formattedValue = `${country.telephonePrefix} ${newValue}`;
      onChange(formattedValue);
      return;
    }
    if (isRemovingNumber) {
      if (newValue.length < prefixLength) {
        return;
      }
      if (cleanedValue === "") {
        onChange("");
      } else {
        onChange(newValue);
      }
    } else {
      const formattedValue = `${country.telephonePrefix} ${cleanedValue.substring(prefixLength, prefixLength + 3)} ${cleanedValue.substring(
        prefixLength + 3,
        prefixLength + 3 + 11,
      )}`;
      onChange(formattedValue);
    }
    setPreviousValue(cleanedValue);
  };

  return (
    <>
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "row", md: "column" }, // row on mobile, column on md+
          gap: 2,
        }}
      >
        <TextField
          sx={{
            width: { xs: "40%", md: "25%" }, // narrower on mobile
            "& .MuiInputBase-root": {
              height: 56, // keep height aligned
            },
          }}
          select
          size="medium"
          label="Vorwahl"
          value={country.telephonePrefix}
          onChange={handleCountryChange}
        >
          {countries.map((country) => (
            <MenuItem key={country.value} value={country.telephonePrefix}>
              <div style={{ height: "24px", width: "32px", display: "flex" }}>
                <img src={country.icon} />
              </div>
              {country.text}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          size="medium"
          label={label ? label : "Telephone Number"}
          variant="outlined"
          fullWidth
          value={value}
          onChange={handleInputChange}
          inputProps={{
            maxLength: 17,
          }}
        />
      </Box> */}
      <Box sx={{ display: { xs: "inline-block", md: "inline-block ", lg: "flex", xl: "flex", width: "100%" } }}>
        <FormControl   sx={{
              mb: { xs: 2, md: 2, lg: 0, xl: 0, width: 0 },
              mr: { xs: 0, md: 0, lg: 2, xl: 2, width: 2 },
              
              width: { xs: "100%", md: "100%", lg: "25%", xl: "25%", width: "25%" },
              "& .MuiSelectBase-root": {
                height: 64, // keep height aligned
              },
            }}>
          <InputLabel id="vorwahlSelectLabel">Vorwahl</InputLabel>
          <Select
           
            labelId="vorwahlSelectLabel"
            input={<OutlinedInput size="small" label="Vorwahl" />}
            value={country.telephonePrefix}
            onChange={handleCountryChange}
            renderValue={(e) => {
              const country = countries.find((land) => land.telephonePrefix === e);
              return (
                <>
                  <div style={{ height: "24x", width: "32px" }}>
                    <img src={country.icon} />
                  </div>
                  <Typography>{country.text}</Typography>
                </>
              );
            }}
          >
            {countries.map((country) => (
              <MenuItem key={country.value} value={country.telephonePrefix}>
                <div style={{ height: "24px", width: "32px" }}>
                  <img src={country.icon} />
                </div>
                <Typography sx={{ marginLeft: 2 }}>{country.text}</Typography>
              </MenuItem>
            ))}
          </Select>{" "}
        </FormControl>
        <TextField
          sx={{
            "& .MuiInputBase-root": {
              height: 70, // keep height aligned
            },
          }}
          size="medium"
          label={label ? label : "Telephone Number"}
          variant="outlined"
          fullWidth
          value={value}
          onChange={handleInputChange}
          inputProps={{
            maxLength: 17, // Adjust maxLength based on country code length
          }}
        />
      </Box>
    </>
  );
};

export default TelephoneInput;
